module.exports = __webpack_public_path__ + "img/rhlogo.8e627678.png";